import { render, staticRenderFns } from "./MedicineAtoZList.vue?vue&type=template&id=11585cff&scoped=true&"
import script from "./MedicineAtoZList.vue?vue&type=script&lang=js&"
export * from "./MedicineAtoZList.vue?vue&type=script&lang=js&"
import style0 from "./MedicineAtoZList.vue?vue&type=style&index=0&id=11585cff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11585cff",
  null
  
)

export default component.exports